import { Injectable, OnDestroy } from '@angular/core';

import { fuseConfig } from 'app/fuse-config';
import { FuseConfig } from '@fuse/types';
import { HttpClient } from '@angular/common/http';
import { Subject, BehaviorSubject, Subscription, Observable } from 'rxjs';
import { Resolve } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { timer } from 'rxjs';
import { CompanyService } from './company.service';


@Injectable()
export class CalendarService implements Resolve<any> {
    public _unsubscribeAll: Subject<any>;
    public _fuseConfig: FuseConfig;

    companyId: any;
    calendarLastDate: string;

    onCompanyChanged: BehaviorSubject<any>;
    onEventTypesUpdated: Subject<any>;
    onMonthlyEventsUpdated: Subject<any>;
    onTeamEventsUpdated: Subject<any>;
    onNonWorkinEventsUpdated: Subject<any>;
    onEventsUpdated: Subject<any>;

    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        public _httpClient: HttpClient,
        private _companyService: CompanyService
    ) {
        this._fuseConfig = fuseConfig;
        this._unsubscribeAll = new Subject();

        this.onCompanyChanged = new BehaviorSubject([]);
        this.onEventTypesUpdated = new Subject();
        this.onMonthlyEventsUpdated = new Subject();
        this.onTeamEventsUpdated = new Subject();
        this.onNonWorkinEventsUpdated = new Subject();
        this.onEventsUpdated = new Subject();

        this._companyService.getActiveCompany().then(data => {
            this.companyId = data.id;
        });

    }

    /**
     * Resolver
     *
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(): Observable<any> | Promise<any> | any {
        return new Promise<void>((resolve, reject) => {
            Promise.all([
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    /**
     * @param date GGGG-MM-DD
     */
    public getMonthlyEvents(date: string = this.calendarLastDate, companyId: number = this.companyId): Promise<any> {

        if (!date) {
            const today = new Date();
            const dd = String(today.getDate()).padStart(2, '0');
            const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
            const yyyy = today.getFullYear();
            date = yyyy + '-' + mm;
        }
        this.calendarLastDate = date;

        const params = {
            date: date
        };

        return new Promise((resolve, reject) => {
            this._httpClient.post(this._fuseConfig.api.url + '/portal/erp/' + companyId + '/events/personal/monthly', params)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.onMonthlyEventsUpdated.next(response);
                        resolve(response);
                    }, reject);
        });

    }

    public getTeamWorkSchedule(date: string, companyId: number = this.companyId): Promise<any> {

        const params = {
            date: date
        };

        return new Promise((resolve, reject) => {
            this._httpClient.post(this._fuseConfig.api.url + '/portal/erp/' + companyId + '/events/team-work-schedule/monthly', params)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.onTeamEventsUpdated.next(response);
                        resolve(response);
                    }, reject);
        });

    }

    public getNonWorkingDays(date: string, companyId: number = this.companyId): Promise<any> {

        const params = {
            date: date
        };

        return new Promise((resolve, reject) => {
            this._httpClient.post(this._fuseConfig.api.url + '/portal/erp/' + companyId + '/events/non-working-days/monthly', params)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.onNonWorkinEventsUpdated.next(response);
                        resolve(response);
                    }, reject);
        });

    }

    public getEvent(id: number, companyId: number = this.companyId): Promise<any> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this._fuseConfig.api.url + '/portal/erp/' + companyId + '/events/' + id + '/get')
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.onEventsUpdated.next(response);
                        resolve(response);
                    }, reject);
        });

    }


}
